import React from "react";
import { useResetPassword } from "./hooks";
import { useForm } from "react-hook-form";
import { Forms } from "@/types/form";
import schemas from "@/utils/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { Typography, Button } from "@mui/material";
import { Styled } from "./styles";
import { Input } from "@dippi/ui";

interface Props {
    oobCode: string | null;
}

const PasswordReset: React.FC<Props> = ({ oobCode }) => {
    const onResetPassword = useResetPassword();

    const { control, handleSubmit } = useForm<Forms["ResetPassword"]>({
        resolver: yupResolver(schemas.resetPassword),
        defaultValues: { newPassword: "", confirmPassword: "" },
    });

    const onSubmit = async (data: Forms["ResetPassword"]) => {
        const { confirmPassword } = data;
        await onResetPassword(confirmPassword, oobCode);
    };

    return (
        <Styled.Form onSubmit={handleSubmit(onSubmit)}>
            <Typography variant="h3" textAlign="center">
                Choose a new password
            </Typography>
            <Styled.Inputs>
                <Input
                    name="newPassword"
                    control={control}
                    label="New password"
                    type="password"
                    className="sentry-mask"
                />
                <Input
                    name="confirmPassword"
                    control={control}
                    type="password"
                    size="medium"
                    label="Confirm password"
                    className="sentry-mask"
                />
            </Styled.Inputs>
            <Button type="submit" fullWidth={true}>
                Reset password
            </Button>
        </Styled.Form>
    );
};

export default PasswordReset;
